export default __webpack_public_path__ + "static/media/marzbani.1fc27333.png";